/**
 * Determines whether a task should currently be visible to the client.
 * Returns true if `visible_on` is the sentinel string "Always Visible"
 * or if the scheduled visibility date is in the past.
 *
 * @param {object} task              - Task object
 * @param {string} task.visible_on   - ISO date string or "Always Visible"
 * @returns {boolean} True if the task is currently visible
 */
const isVisibleNowFunction = (task) => {
    if (task.visible_on === "Always Visible") return true;
    if (new Date(task.visible_on).getTime() < new Date().getTime()) return true
    return false
}

export default isVisibleNowFunction; 